// src/components/TicketDetail.tsx
import React from "react";
import { TicketMessages } from "./TicketMessages";
import { TicketModel } from "../../types/index";
import { useTranslation } from "react-i18next";

type Props = {
  ticket: TicketModel;
  vendorId: string;
};

function formatTimestamp(ts: any) {
  try {
    if (!ts) return "";
    if (ts.toDate) {
      return ts.toDate().toLocaleString("tr-TR");
    }
    const d = new Date(ts);
    return d.toLocaleString("tr-TR");
  } catch {
    return "";
  }
}

export const TicketDetail: React.FC<Props> = ({ ticket, vendorId }) => {
  const { t } = useTranslation();
  if (!ticket) return <div>{t("ticketNotSelected")}</div>;

  return (
    <div className="flex flex-col h-full min-h-0 gap-3">
      <div className="support-detail-header shrink-0">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: 'var(--accent-color)', color: '#fff' }}>
            <i className="dx-icon dx-icon-help" style={{ fontSize: 20 }} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-base font-semibold truncate">{ticket.title}</div>
            <div className="text-xs support-text-muted flex items-center gap-2 mt-0.5">
              <span>{ticket.topic ?? t("general")}</span>
              <span style={{ opacity: 0.4 }}>|</span>
              <span>{ticket.ticket_code}</span>
              <span style={{ opacity: 0.4 }}>|</span>
              <span>{formatTimestamp(ticket.createdAt)}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <TicketMessages vendorId={vendorId} ticketId={ticket.id} ticketStatus={ticket.status} ticket={ticket} />
      </div>
    </div>
  );
};
